"use client";

import { ChevronDown } from "lucide-react";
import { usePathname } from "next/navigation";

import useMoengageEventTracker from "@/hooks/use-moengage";
import EVENT_NAME from "@/hooks/use-moengage/event-name.json";

import { cn } from "@/lib/utils";

function AllCoursesButton() {
  const pathName = usePathname();
  const trackMoengageEvent = useMoengageEventTracker();

  return (
    <button
      type="button"
      className={cn(
        "hidden md:flex items-center gap-x-3 py-2 px-4 rounded-lg h-10",
        "text-primary border border-primary/60 invisible md:visible",
        pathName === "/" && "visible"
      )}
      onClick={() => {
        const toggleHeaderBottomBarEvent = new Event("toggleHeaderBottomBar");
        window.dispatchEvent(toggleHeaderBottomBarEvent);
        trackMoengageEvent(EVENT_NAME.HOMEPAGE_ALL_COURSE_CLICKED);
      }}
      data-testid="all-courses-button"
    >
      <span className="text-sm font-semibold">All Courses</span>
      <ChevronDown size={16} className="mt-1 scale-120" />
    </button>
  );
}

export default AllCoursesButton;
